import { Reducer } from 'redux';
import { EtrmConfigActionEnum, EtrmConfigActions, IEtrmConfigState } from '.';
import {
  IEtrmConfig
} from '../../services';

export const initialState: IEtrmConfigState = {
  loading: true,
  isEtrmConfigPostSuccess: false,
  etrmConfigs: [] as IEtrmConfig[],
  etrmConfig: {} as IEtrmConfig,
  exceptionMessage: '',
  message: '',
};

export const etrmConfigReducer: Reducer<IEtrmConfigState, EtrmConfigActions> = (
    state = initialState,
    action: EtrmConfigActions
) => {
  switch (action.type) {
    case EtrmConfigActionEnum.FetchEtrmConfig:
      return {
        ...state,
        loading: true,
      };
    case EtrmConfigActionEnum.FetchEtrmConfigSuccess:
      return {
        ...state,
        loading: false,
        etrmConfigs: action.state?.etrmConfigs,
      };
    case EtrmConfigActionEnum.FetchEtrmConfigFailed:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
    case EtrmConfigActionEnum.PostEtrmConfig:
      return {
        ...state,
        loading: true,
        isEtrmConfigPostSuccess: false,
      };
    case EtrmConfigActionEnum.PostEtrmConfigSuccess:
      return {
        ...state,
        loading: false,
        isEtrmConfigPostSuccess: true,
        message: action.state?.message,
      };
    case EtrmConfigActionEnum.PostEtrmConfigFailed:
      return {
        ...state,
        loading: false,
        isEtrmConfigPostSuccess: false,
        exceptionMessage: action.state?.exceptionMessage,
      };

    default:
      return state;
  }
};
